/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;



//////////////////
// WEBPACK FOOTER
// ./~/victory-create-container/~/lodash/_baseLodash.js
// module id = ./node_modules/victory-create-container/node_modules/lodash/_baseLodash.js
// module chunks = 1